import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { PartiesRoutes } from '../../../Router/path';
import PartyForm from '../Components/PartyForm/PartyForm';
import { partyInitialValues } from '../initialValues';
import { extractPartiesErrorFeedback } from '../Service/partiesMapper';
import { useCreatePartyMutation } from '../Service/partiesApi';
import { mapPartyFormValuesToRequest } from '../Types/partyTypes';

const CreateParty = () => {
  const navigate = useNavigate();
  const [submitErrorMessage, setSubmitErrorMessage] = useState<string | null>(null);
  const [createParty, createStatus] = useCreatePartyMutation();

  useEffect(() => {
    if (!createStatus.isSuccess) {
      return;
    }

    const timeout = window.setTimeout(() => {
      navigate(PartiesRoutes.root);
    }, 1200);

    return () => window.clearTimeout(timeout);
  }, [createStatus.isSuccess, navigate]);

  return (
    <Box>
      <PartyForm
        mode="create"
        initialValues={partyInitialValues}
        isSubmitting={createStatus.isLoading}
        isSuccess={createStatus.isSuccess}
        submitErrorMessage={submitErrorMessage}
        onSubmit={async (values) => {
          setSubmitErrorMessage(null);

          try {
            await createParty(mapPartyFormValuesToRequest(values)).unwrap();
          } catch (error) {
            const feedback = extractPartiesErrorFeedback(
              error,
              'Nie udało się utworzyć strony. Zweryfikuj formularz i spróbuj ponownie.'
            );
            setSubmitErrorMessage(feedback.message);
          }
        }}
        onCancel={() => navigate(PartiesRoutes.root)}
      />
    </Box>
  );
};

export default CreateParty;

